export const GuestStatus = {
    CONFIRMED: 1,
    PENDING_PAYMENT: 2,
    PENDING_INVITATION: 3,
    DECLINED: 4,
} as const;

export interface ExperienceGuestInfo {
    id: number;
    email: string;
    fullName: string;
    profilePicture: string;
    status?: number;
    updatedAt?: string;
    createdAt?: string;
    bookingId?: number;
    firstName?: string;
    lastName?: string;
    tickets?: number;
    purchaseDate?: string;
}